import "./styles.css";
import { Legal } from "./pages/Legal";
import { PRIVACY_MD } from "./pages/legalContent";
import { mount } from "./hydrate";

mount(
  <Legal
    title="Privacy Policy"
    content={PRIVACY_MD}
    otherHref="/terms/"
    otherLabel="our Terms of Service"
  />,
);
